import { Box, CircularProgress } from '@mui/material'
import React from 'react'

type HeaderCountBadgeProps = {
  count: number
  isLoading?: boolean
}

const HeaderCountBadge = ({ count, isLoading }: HeaderCountBadgeProps) => {
  return (
    <Box
      component="span"
      sx={{
        ml: 1,
        px: 1,
        py: 0.25,
        backgroundColor: 'background.elevation3',
        borderRadius: '8px',
        fontSize: '0.875rem',
        fontWeight: 'bold',
        height: 'fit-content',
      }}
    >
      {isLoading ? <CircularProgress size={10} /> : count}
    </Box>
  )
}

export default HeaderCountBadge